export const EXPOSE_AUTOMATION_VARIANTS = [
  { key: 'expose-projektverkauf', label: 'Exposé PV' },
  { key: 'expose-turnkey', label: 'Exposé Turnkey' },
  { key: 'expose-wirtschaftlichkeit', label: 'Wirtschaftlichkeit' },
];

export const DEFAULT_EXPOSE_BITRIX_MAPPING = {
  Projektname: 'DEAL.TITLE',
  Kundenname: 'CONTACT.NAME,CONTACT.LAST_NAME',
  Kundenadresse: 'UF_CRM_1750851805',
  Angebotsnummer: 'DEAL.ID',
  Kundennummer: 'DEAL.ID',
  Projektbild: 'UF_CRM_1768782056729',
  Lageplan: 'UF_CRM_1740525963072',

  'Leistung kWp': 'UF_CRM_1750195757',
  'Belegbare Fläche': 'UF_CRM_1750681589491',
  Spezifischertrag: 'UF_CRM_1747953183029',

  'Preis pro kWp': 'UF_CRM_1752353497695',
  Bundesland: 'UF_CRM_1729875617742',
  Gemarkung: 'UF_CRM_1752323992',
  Flurstück: 'UF_CRM_1752324013',
  Pachtbeginn: 'UF_CRM_1765075681161',
  Pachtkosten: 'UF_CRM_1750205748',
  Amtsgericht: 'UF_CRM_1752319556769',

  Netzbetreiber: 'UF_CRM_1740652923353',

  // Hinweis: 'E-Mail' und 'Preis Projektrecht pro kWp' haben BEWUSST keinen Bitrix-Default
  // mehr (Nutzerwunsch: manuelle Werte + Feldschutz). Ein leerer bzw. fehlender Default sorgt
  // zusammen mit der Keep-Empty-Ladelogik dafür, dass diese Felder nicht mehr aus Bitrix kommen.

  'Projekt-ID': 'DEAL.ID',
  Projektstandort: 'UF_CRM_1750851805',
  Standort: 'UF_CRM_1750851805',
  kWp: 'UF_CRM_1750195757',
  'Art der Pacht': 'UF_CRM_1747952327968',
  'Einmalzahlung Pacht pro kWp': 'UF_CRM_1752353497695',
  'Einmalzahlung Pacht Gesamt': 'UF_CRM_1750206982',
  'Jährliche Zahlung': 'UF_CRM_1750205748',
  'Kaufpreis Projektrecht': 'UF_CRM_1750206982',
  // 'Preis Projektrecht pro kWp' bewusst ohne Default (siehe Hinweis oben).
  'Kaufpreis Turnkey': 'UF_CRM_1768782070085',
  'VL Prozent': 'UF_CRM_1749574294404',
  'Grundbuch belastet': 'UF_CRM_1783972092027',
  Gemeinde: 'UF_CRM_1752311946586',

  'Grundbucheintragung Dokument': 'UF_CRM_1747954126',
  'Netzzusage Dokument': 'UF_CRM_1769727767515',
  'Grundbuch belastet Bitrix': 'UF_CRM_1783972092027',
  'Rangrücktritt Dokument': 'UF_CRM_1783972120825',
};

export const REMOVED_BITRIX_MAPPING_KEYS = new Set([
  'Datum', 'Dachfläche', 'Kaufpreis', 'Modulleistung', 'Status',
  'Pachtvertrag Status', 'Pachtlaufzeit', 'Verlängerungsoption',
  'Kaufpreis Turnkey pro kWp', 'Netzstatus', 'Netzanschluss',
  'Spannungsebene', 'Netzverknüpfungspunkt', 'Netzentfernung',
  'Ansprechpartner', 'Telefonnummer',
]);

export const REMOVED_BITRIX_DATA_KEYS = new Set([
  'datum', 'dachflaeche', 'dachfläche', 'kaufpreis', 'gesamtpreis', 'projektpreis',
  'modulleistung', 'status', 'pachtvertrag_status', 'pachtlaufzeit',
  'verlaengerungsoption', 'turnkey_preis_kwp', 'netzstatus', 'netzanschluss',
  'spannungsebene', 'netzverknuepfungspunkt', 'netzentfernung',
  'ansprechpartner', 'telefonnummer',
]);

const LEGACY_EXPOSE_MAPPING_REPLACEMENTS = {
  Projektbild: {
    UF_CRM_1755781964: 'UF_CRM_1768782056729',
  },
  'Kaufpreis Turnkey pro kWp': {
    UF_CRM_1768782056729: 'UF_CRM_1768781625378',
  },
  // UF_CRM_1752320167037 ist in Bitrix „Nutzungsentgelt VL .KS - BESS“ (Zahl), kein Grundbuchfeld.
  'Grundbuch belastet': {
    UF_CRM_1752320167037: 'UF_CRM_1783972092027',
  },
};

export function normalizeExposeMappingFieldValue(placeholder, value) {
  const raw = String(value || '').trim();
  if (!raw) return '';
  return LEGACY_EXPOSE_MAPPING_REPLACEMENTS[placeholder]?.[raw] || raw;
}

export function compactExposeMappingFields(fields = {}) {
  if (!fields || typeof fields !== 'object') return {};
  return Object.fromEntries(
    Object.entries(fields)
      .map(([key, value]) => {
        const placeholder = String(key || '').trim();
        return [placeholder, normalizeExposeMappingFieldValue(placeholder, value)];
      })
      .filter(([key, value]) => key && value)
  );
}

const BASE_EXPOSE_PLACEHOLDER_FIELDS = [
  { placeholder: 'Projektname', dataKeys: ['projektname', 'turnkeyProjektname', 'dealTitle'], group: 'Projekt' },
  { placeholder: 'Kundenname', dataKeys: ['kundenname'], group: 'Projekt' },
  { placeholder: 'Kundenadresse', dataKeys: ['kundenadresse', 'standort'], group: 'Projekt' },
  { placeholder: 'Angebotsnummer', dataKeys: ['angebotsnummer', 'turnkeyAngebotsnummer'], group: 'Projekt' },
  { placeholder: 'Kundennummer', dataKeys: ['kundennummer'], group: 'Projekt' },
  { placeholder: 'Datum', dataKeys: ['datum'], group: 'Projekt' },
  { placeholder: 'Gültig bis', dataKeys: ['gueltig_bis'], group: 'Projekt' },
  { placeholder: 'Projektbild', dataKeys: ['projectImage', 'projektbild', 'heroImage', 'image'], group: 'Projekt' },
  { placeholder: 'Lageplan', dataKeys: ['lageplanImage', 'lageplan', 'lageplanBild'], group: 'Projekt' },

  { placeholder: 'Leistung kWp', dataKeys: ['kwp_leistung', 'leistung_kwp', 'leistung'], group: 'Technik' },
  { placeholder: 'Dachfläche', dataKeys: ['dachflaeche', 'dachfläche'], group: 'Technik' },
  { placeholder: 'Belegbare Fläche', dataKeys: ['belegbare_flaeche'], group: 'Technik' },
  { placeholder: 'Spezifischertrag', dataKeys: ['spezifischertrag'], group: 'Technik' },
  { placeholder: 'Jahresertrag', dataKeys: ['jahresertrag'], group: 'Technik' },
  { placeholder: 'Modultyp', dataKeys: ['modultyp'], group: 'Technik' },
  { placeholder: 'Modulanzahl', dataKeys: ['modulanzahl'], group: 'Technik' },
  { placeholder: 'Modulleistung', dataKeys: ['modulleistung'], group: 'Technik' },
  { placeholder: 'Wechselrichter', dataKeys: ['wechselrichter'], group: 'Technik' },
  { placeholder: 'Wechselrichter Anzahl', dataKeys: ['wechselrichter_anzahl'], group: 'Technik' },

  { placeholder: 'Kaufpreis', dataKeys: ['kaufpreis', 'gesamtpreis', 'projektpreis'], group: 'Wirtschaft' },
  { placeholder: 'Preis pro kWp', dataKeys: ['preis_pro_kwp', 'preis_kwp', 'kaufpreis_pro_kwp'], group: 'Wirtschaft' },
  { placeholder: 'IRR', dataKeys: ['irr'], group: 'Wirtschaft' },
  { placeholder: 'Rendite', dataKeys: ['rendite'], group: 'Wirtschaft' },
  { placeholder: 'Amortisation', dataKeys: ['payback'], group: 'Wirtschaft' },
  { placeholder: 'EEG Vergütung', dataKeys: ['eeg_verguetung'], group: 'Wirtschaft' },
  { placeholder: 'Jahreserlös', dataKeys: ['jahreserloes'], group: 'Wirtschaft' },
  { placeholder: 'EEG Anteil', dataKeys: ['eeg_anteil'], group: 'Wirtschaft' },
  { placeholder: 'Netto Vergütung', dataKeys: ['netto_verguetung'], group: 'Wirtschaft' },
  { placeholder: 'Dachpacht', dataKeys: ['dachpacht'], group: 'Wirtschaft' },
  { placeholder: 'Versicherung', dataKeys: ['versicherung'], group: 'Wirtschaft' },
  { placeholder: 'Wartung', dataKeys: ['wartung'], group: 'Wirtschaft' },
  { placeholder: 'OPEX', dataKeys: ['opex'], group: 'Wirtschaft' },
  { placeholder: 'Netto Erlös 20 Jahre', dataKeys: ['netto_erloes_25j'], group: 'Wirtschaft' },

  { placeholder: 'Projektstatus', dataKeys: ['status', 'projektstatus'], group: 'Status' },
  { placeholder: 'Inbetriebnahme', dataKeys: ['inbetriebnahme'], group: 'Status' },
  { placeholder: 'Bundesland', dataKeys: ['bundesland'], group: 'Status' },
  { placeholder: 'Gemarkung', dataKeys: ['gemarkung'], group: 'Status' },
  { placeholder: 'Flurstück', dataKeys: ['flurstueck', 'flurstück'], group: 'Status' },
  { placeholder: 'Grundbuchblatt', dataKeys: ['grundbuchblatt'], group: 'Status' },
  { placeholder: 'Dachtyp', dataKeys: ['dachtyp'], group: 'Status' },
  { placeholder: 'Pachtvertrag Status', dataKeys: ['pachtvertrag_status'], group: 'Status' },
  { placeholder: 'Pachtlaufzeit', dataKeys: ['pachtlaufzeit'], group: 'Status' },
  { placeholder: 'Pachtbeginn', dataKeys: ['pachtbeginn'], group: 'Status' },
  { placeholder: 'Pachtkosten', dataKeys: ['pachtkosten'], group: 'Status' },
  { placeholder: 'Statikgutachten Status', dataKeys: ['statikgutachten_status'], group: 'Status' },
  { placeholder: 'Grundbucheintragung Status', dataKeys: ['grundbucheintragung_status'], group: 'Status' },
  { placeholder: 'Gestattungsverträge Status', dataKeys: ['gestattungsvertraege_status'], group: 'Status' },

  { placeholder: 'Netzstatus', dataKeys: ['netzstatus'], group: 'Netz' },
  { placeholder: 'Netzanschluss', dataKeys: ['netzanschluss'], group: 'Netz' },
  { placeholder: 'Spannungsebene', dataKeys: ['spannungsebene'], group: 'Netz' },
  { placeholder: 'Netzverknüpfungspunkt', dataKeys: ['netzverknuepfungspunkt'], group: 'Netz' },
  { placeholder: 'Netzentfernung', dataKeys: ['netzentfernung'], group: 'Netz' },
  { placeholder: 'Netzbetreiber', dataKeys: ['netzbetreiber'], group: 'Netz' },
  { placeholder: 'Netzzusage Dokument', dataKeys: ['_netzzusage_dok'], group: 'Netz' },

  { placeholder: 'PVSol Standort', dataKeys: ['pvsol_standort'], group: 'PVSol' },
  { placeholder: 'PVSol Quelle', dataKeys: ['pvsol_quelle'], group: 'PVSol' },
  { placeholder: 'PVSol Generatorleistung', dataKeys: ['pvsol_generatorleistung'], group: 'PVSol' },
  { placeholder: 'PVSol Spezifischer Jahresertrag', dataKeys: ['pvsol_jahresertrag_spez'], group: 'PVSol' },
  { placeholder: 'PVSol Netzeinspeisung', dataKeys: ['pvsol_netzeinspeisung'], group: 'PVSol' },
  { placeholder: 'PVSol CO2', dataKeys: ['pvsol_co2'], group: 'PVSol' },
  { placeholder: 'PVSol Generatorfläche', dataKeys: ['pvsol_generatorflaeche'], group: 'PVSol' },
  { placeholder: 'PVSol Module', dataKeys: ['pvsol_module'], group: 'PVSol' },
  { placeholder: 'PVSol Wechselrichter', dataKeys: ['pvsol_wechselrichter'], group: 'PVSol' },

  { placeholder: 'Amtsgericht', dataKeys: ['amtsgericht'], group: 'Grundbuch' },
  { placeholder: 'Grundbuch Abdruck vom', dataKeys: ['grundbuch_abdruck_vom'], group: 'Grundbuch' },
  { placeholder: 'Grundbuch belastet', dataKeys: ['grundbuch_belastet'], group: 'Grundbuch' },
  { placeholder: 'Rangrücktritt', dataKeys: ['rangruecktritt'], group: 'Grundbuch' },
  { placeholder: 'Grundbucheintragung Dokument', dataKeys: ['_grundbucheintragung_dok'], group: 'Grundbuch' },
  { placeholder: 'Grundbuch belastet Bitrix', dataKeys: ['_grundbuch_belastet_raw'], group: 'Grundbuch' },
  { placeholder: 'Rangrücktritt Dokument', dataKeys: ['_rangruecktritt_dok'], group: 'Grundbuch' },

  { placeholder: 'Ansprechpartner', dataKeys: ['ansprechpartner'], group: 'Kontakt' },
  { placeholder: 'Position', dataKeys: ['position'], group: 'Kontakt' },
  { placeholder: 'Telefonnummer', dataKeys: ['telefonnummer'], group: 'Kontakt' },
  { placeholder: 'E-Mail', dataKeys: ['email'], group: 'Kontakt' },
  { placeholder: 'Website', dataKeys: ['website'], group: 'Kontakt' },
];

const EXPOSE_TEMPLATE_ONLY_PLACEHOLDER_FIELDS = [
  { placeholder: 'Projekt-ID', dataKeys: ['projekt_id'], group: 'Projekt' },
  { placeholder: 'Status', dataKeys: ['status'], group: 'Projekt' },
  { placeholder: 'Gemeinde', dataKeys: ['gemeinde'], group: 'Projekt' },
  { placeholder: 'Projektstandort', dataKeys: ['standort'], group: 'Projekt' },
  { placeholder: 'Kaufpreis Projektrecht', dataKeys: ['projektrecht_kaufpreis'], group: 'Wirtschaft' },
  { placeholder: 'Preis Projektrecht pro kWp', dataKeys: ['preis_projektrecht'], group: 'Wirtschaft' },
  { placeholder: 'Kaufpreis Turnkey', dataKeys: ['turnkey_kaufpreis'], group: 'Wirtschaft' },
  { placeholder: 'Kaufpreis Turnkey pro kWp', dataKeys: ['turnkey_preis_kwp'], group: 'Wirtschaft' },
  { placeholder: 'Art der Pacht', dataKeys: ['pachtart'], group: 'Wirtschaft' },
  { placeholder: 'Einmalzahlung Pacht pro kWp', dataKeys: ['pacht_einmal_kwp'], group: 'Wirtschaft' },
  { placeholder: 'Einmalzahlung Pacht Gesamt', dataKeys: ['pacht_einmal_gesamt'], group: 'Wirtschaft' },
  { placeholder: 'Jährliche Zahlung', dataKeys: ['jaehrliche_zahlung'], group: 'Wirtschaft' },
  { placeholder: 'Verlängerungsoption', dataKeys: ['verlaengerungsoption'], group: 'Wirtschaft' },
  { placeholder: 'VL Prozent', dataKeys: ['vl_prozent'], group: 'Wirtschaft' },
  { placeholder: 'Sanierungsbedarf', dataKeys: ['sanierungsbedarf'], group: 'Status' },
  { placeholder: 'Statik-Vorprüfung', dataKeys: ['statik_vorpruefung'], group: 'Status' },
  { placeholder: 'Statik-Gutachten angefordert', dataKeys: ['statikgutachten_angefordert'], group: 'Status' },
  { placeholder: 'Freigabe Statiker', dataKeys: ['statiker_freigabe'], group: 'Status' },
  { placeholder: 'O&M Vertrag', dataKeys: ['om_vertrag'], group: 'Status' },
  { placeholder: 'Cashflow Jahr 1', dataKeys: ['cashflow_1_jahr'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow Ertrag 1', dataKeys: ['cashflow_1_ertrag'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow Erlös 1', dataKeys: ['cashflow_1_erloes'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow OPEX 1', dataKeys: ['cashflow_1_opex'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow Netto 1', dataKeys: ['cashflow_1_netto'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow Jahr 5', dataKeys: ['cashflow_2_jahr'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow Ertrag 5', dataKeys: ['cashflow_2_ertrag'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow Erlös 5', dataKeys: ['cashflow_2_erloes'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow OPEX 5', dataKeys: ['cashflow_2_opex'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow Netto 5', dataKeys: ['cashflow_2_netto'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow Jahr 10', dataKeys: ['cashflow_3_jahr'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow Ertrag 10', dataKeys: ['cashflow_3_ertrag'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow Erlös 10', dataKeys: ['cashflow_3_erloes'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow OPEX 10', dataKeys: ['cashflow_3_opex'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow Netto 10', dataKeys: ['cashflow_3_netto'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow Jahr 15', dataKeys: ['cashflow_4_jahr'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow Ertrag 15', dataKeys: ['cashflow_4_ertrag'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow Erlös 15', dataKeys: ['cashflow_4_erloes'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow OPEX 15', dataKeys: ['cashflow_4_opex'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow Netto 15', dataKeys: ['cashflow_4_netto'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow Jahr 20', dataKeys: ['cashflow_5_jahr'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow Ertrag 20', dataKeys: ['cashflow_5_ertrag'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow Erlös 20', dataKeys: ['cashflow_5_erloes'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow OPEX 20', dataKeys: ['cashflow_5_opex'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow Netto 20', dataKeys: ['cashflow_5_netto'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow Jahr 25', dataKeys: ['cashflow_6_jahr'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow Ertrag 25', dataKeys: ['cashflow_6_ertrag'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow Erlös 25', dataKeys: ['cashflow_6_erloes'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow OPEX 25', dataKeys: ['cashflow_6_opex'], group: 'Turnkey Cashflow' },
  { placeholder: 'Cashflow Netto 25', dataKeys: ['cashflow_6_netto'], group: 'Turnkey Cashflow' },
  { placeholder: 'Stromgestehungskosten', dataKeys: ['stromgestehungskosten'], group: 'Wirtschaftlichkeit' },
  { placeholder: 'Eigenkapitalrendite', dataKeys: ['eigenkapitalrendite'], group: 'Wirtschaftlichkeit' },
  { placeholder: 'Betrachtungszeitraum', dataKeys: ['betrachtungszeitraum'], group: 'Wirtschaftlichkeit' },
  { placeholder: 'Degradation', dataKeys: ['degradation'], group: 'Wirtschaftlichkeit' },
  { placeholder: 'Vergütungszeitraum', dataKeys: ['verguetungszeitraum'], group: 'Wirtschaftlichkeit' },
  { placeholder: 'EEG Tarif Name', dataKeys: ['eeg_tarif_name'], group: 'Wirtschaftlichkeit' },
  { placeholder: 'Wirtschaftlichkeit Cashflow JSON', dataKeys: ['wirtschaftlichkeit_cashflow_json'], group: 'Wirtschaftlichkeit' },
  { placeholder: 'Inbetriebnahme Datum', dataKeys: ['inbetriebnahme_datum'], group: 'Wirtschaftlichkeit' },
  { placeholder: 'Netzeinspeisung', dataKeys: ['netzeinspeisung'], group: 'Wirtschaftlichkeit' },
  { placeholder: 'Kapitalwert', dataKeys: ['kapitalwert'], group: 'Wirtschaftlichkeit' },
  { placeholder: 'Gesamtvergütung', dataKeys: ['gesamtverguetung'], group: 'Wirtschaftlichkeit' },
  { placeholder: 'EEG Vergütungsstufen JSON', dataKeys: ['eeg_verguetungsstufen_json'], group: 'Wirtschaftlichkeit' },
];

export const EXPOSE_PLACEHOLDER_FIELDS = [
  ...BASE_EXPOSE_PLACEHOLDER_FIELDS,
  ...EXPOSE_TEMPLATE_ONLY_PLACEHOLDER_FIELDS,
];

const KNOWN_EXPOSE_PLACEHOLDERS = new Set(EXPOSE_PLACEHOLDER_FIELDS.map((field) => field.placeholder));

// Wie compactExposeMappingFields, aber Leerstrings bleiben ERHALTEN: Ein gespeicherter leerer
// Wert ist eine bewusste Entfernung durch den Nutzer und muss den Default aus buildInitialMapping
// überschreiben (sonst kommt das Mapping beim Laden immer wieder zurück). Nur Einträge mit leerem
// Key fliegen raus. Unbekannte Platzhalter (nicht in EXPOSE_PLACEHOLDER_FIELDS) werden nur behalten,
// wenn sie einen nicht-leeren Wert tragen – so verstopfen alte, geleerte Keys nicht den
// staleFieldKeys-Chip-Bereich im Mapping-Editor.
export function normalizeExposeMappingFieldsKeepEmpty(fields = {}) {
  if (!fields || typeof fields !== 'object') return {};
  return Object.fromEntries(
    Object.entries(fields)
      .map(([key, value]) => {
        const placeholder = String(key || '').trim();
        return [placeholder, normalizeExposeMappingFieldValue(placeholder, value)];
      })
      .filter(([key, value]) => key && (value || KNOWN_EXPOSE_PLACEHOLDERS.has(key)))
  );
}

// Bekannte Alt-/Müll-Mappingwerte je Platzhalter. Ein gespeicherter Eintrag wird beim Laden NUR
// dann auf '' gesetzt, wenn sein Wert exakt in dieser Liste steht – bewusst neu gesetzte Mappings
// (anderer Feldpfad) überleben. Ersetzt das frühere unbedingte Blanking über
// REMOVED_BITRIX_MAPPING_KEYS, das Felder wie „Netzanschluss" für immer unmappbar machte.
export const REMOVED_LEGACY_MAPPING_VALUES = {
  'Datum': ['DEAL.DATE_CREATE'],
  'Dachfläche': ['UF_CRM_1768781400428'],
  'Modulleistung': ['UF_CRM_1768781546763'],
  'Kaufpreis': ['UF_CRM_1750206982'],
  'Status': ['UF_CRM_1768817567360', 'UF_CRM_1768815593603'],
  'Projektstatus': ['UF_CRM_1768817567360', 'UF_CRM_1768815593603'],
  'Pachtvertrag Status': ['UF_CRM_1765075517807'],
  'Pachtlaufzeit': ['UF_CRM_1749412087526'],
  'Verlängerungsoption': ['UF_CRM_1749412087526'],
  'Kaufpreis Turnkey pro kWp': ['UF_CRM_1768781625378', 'UF_CRM_1768782056729'],
  'Netzstatus': ['UF_CRM_1761004313945'],
  'Netzanschluss': ['UF_CRM_1765074114505'],
  'E-Mail': ['UF_CRM_1751033919', 'ASSIGNED_USER.EMAIL'],
  'Preis Projektrecht pro kWp': ['UF_CRM_1752353497695'],
};

// Setzt gespeicherte Mappingwerte auf '', wenn sie als bekannter Legacy-/Müllwert gelten
// (wertbasiert, nicht key-basiert). Mutiert das übergebene Objekt nicht.
export function cleanupLegacyExposeMappingValues(fields = {}) {
  if (!fields || typeof fields !== 'object') return {};
  const result = { ...fields };
  Object.entries(REMOVED_LEGACY_MAPPING_VALUES).forEach(([placeholder, legacyValues]) => {
    if (!(placeholder in result)) return;
    const current = normalizeExposeMappingFieldValue(placeholder, result[placeholder]);
    if (current && legacyValues.includes(current)) result[placeholder] = '';
  });
  return result;
}

export function normalizeExposeAutomationVariant(value) {
  const key = String(value || '').trim();
  return EXPOSE_AUTOMATION_VARIANTS.some((variant) => variant.key === key)
    ? key
    : EXPOSE_AUTOMATION_VARIANTS[0].key;
}

export function getExposePlaceholderToken(placeholder) {
  return `{{${placeholder}}}`;
}

export function buildExposePlaceholderData(variantKey = 'expose-projektverkauf') {
  const normalizedVariant = normalizeExposeAutomationVariant(variantKey);
  const data = {
    exposeVariant: normalizedVariant,
    placeholder_mode: true,
    projectImage: '',
  };

  EXPOSE_PLACEHOLDER_FIELDS.forEach((field) => {
    if (field.placeholder === 'Projektbild') return;
    const token = getExposePlaceholderToken(field.placeholder);
    (field.dataKeys || []).forEach((key) => {
      data[key] = token;
    });
  });

  if (normalizedVariant === 'expose-turnkey') {
    data.turnkeyProjektname = getExposePlaceholderToken('Projektname');
    data.turnkeyAngebotsnummer = getExposePlaceholderToken('Angebotsnummer');
  }

  return data;
}

export function buildExposeDataFromResolvedFields(resolvedFields = {}, variantKey = 'expose-projektverkauf', options = {}) {
  const normalizedVariant = normalizeExposeAutomationVariant(variantKey);
  const includePlaceholders = options.includePlaceholders !== false;
  const data = {
    exposeVariant: normalizedVariant,
    placeholder_mode: includePlaceholders,
    projectImage: '',
  };

  EXPOSE_PLACEHOLDER_FIELDS.forEach((field) => {
    const value = String(resolvedFields[field.placeholder] || '').trim();
    const fallback = includePlaceholders && field.placeholder !== 'Projektbild'
      ? getExposePlaceholderToken(field.placeholder)
      : '';
    const finalValue = value || fallback;
    if (!finalValue) return;
    (field.dataKeys || []).forEach((key) => {
      data[key] = finalValue;
    });
  });

  if (normalizedVariant === 'expose-turnkey') {
    if (!data.turnkeyProjektname && data.projektname) data.turnkeyProjektname = data.projektname;
    if (!data.turnkeyAngebotsnummer && data.angebotsnummer) data.turnkeyAngebotsnummer = data.angebotsnummer;
  }

  return data;
}

export function groupExposeFields(fields = EXPOSE_PLACEHOLDER_FIELDS) {
  return fields.reduce((groups, field) => {
    const key = field.group || 'Weitere';
    if (!groups[key]) groups[key] = [];
    groups[key].push(field);
    return groups;
  }, {});
}

// Feldkeys, die die PV*SOL-Extraktion (pvsolToExposeFields in api/_lib/pvsolExtractor.js)
// erzeugen kann. Wird genutzt, um im Mapping-Editor zu markieren, welche Exposé-Felder
// automatisch aus der PV*SOL-Datei befüllt werden. Wirtschaftlichkeits-Kennzahlen
// (irr, payback, cashflow_* usw.) kommen nicht mehr vom Server, sondern werden
// client-seitig berechnet (deriveEconomics/berechneWirtschaftlichkeit).
export const PVSOL_EXPOSE_FIELD_KEYS = new Set([
  'kwp_leistung',
  'pvsol_generatorleistung',
  'netzanschluss',
  'modulanzahl',
  'pvsol_module',
  'spezifischertrag',
  'pvsol_jahresertrag_spez',
  'jahresertrag',
  'pvsol_netzeinspeisung',
  'pvsol_co2',
  'pvsol_generatorflaeche',
  'dachflaeche',
  'pvsol_standort',
  'pvsol_quelle',
  'modultyp',
  'modulleistung',
  'wechselrichter',
  'pvsol_wechselrichter',
  'wechselrichter_anzahl',
  'eeg_tarif_typ',
  'inbetriebnahme_datum',
  'netzeinspeisung',
  'gesamtverguetung',
  'betrachtungszeitraum',
]);

export function isPvsolExposeFieldKey(key) {
  const raw = String(key || '').trim();
  return raw ? PVSOL_EXPOSE_FIELD_KEYS.has(raw) : false;
}

// Felder, die client-seitig automatisch berechnet werden (deriveEconomics / applyAutoCalculations).
// Im Mapping-Editor als "Berechnet" getaggt, damit klar ist: Bitrix/Standardwert wird überschrieben.
export const CALCULATED_EXPOSE_FIELD_KEYS = new Set([
  'eeg_verguetung', 'jahresertrag', 'jahreserloes',
  'projektrecht_kaufpreis', 'turnkey_kaufpreis', 'kaufpreis', 'gesamtpreis',
  'opex', 'turnkey_preis_kwp',
  'irr', 'rendite', 'payback', 'netto_erloes_25j', 'kapitalwert', 'stromgestehungskosten',
  'wirtschaftlichkeit_cashflow_json',
  ...[1, 2, 3, 4, 5, 6].flatMap((i) => [
    `cashflow_${i}_jahr`, `cashflow_${i}_ertrag`, `cashflow_${i}_erloes`, `cashflow_${i}_opex`, `cashflow_${i}_netto`,
  ]),
]);

export function isCalculatedExposeFieldKey(key) {
  const raw = String(key || '').trim();
  return raw ? CALCULATED_EXPOSE_FIELD_KEYS.has(raw) : false;
}

export const AUTO_DEFAULT_EXPOSE_FIELD_KEYS = new Set([
  'datum', 'gueltig_bis',
  'pachtvertrag_status', 'verlaengerungsoption', 'netzstatus', 'spannungsebene',
  'versicherung', 'wartung', 'betrachtungszeitraum', 'degradation',
  'eeg_verguetungsstufen_json',
]);

export function isAutoDefaultExposeFieldKey(key) {
  const raw = String(key || '').trim();
  return raw ? AUTO_DEFAULT_EXPOSE_FIELD_KEYS.has(raw) : false;
}

// Auswahloptionen für Listenfelder — sowohl im Bulk Studio (Select-Renderer)
// als auch im Mapping-Editor (Standardwert-Dropdown) verwendet.
export const EXPOSE_FIELD_OPTIONS = {
  pachtvertrag_status: ['liegt vor', 'In Bearbeitung'],
  grundbucheintragung_status: ['Vorbereitet', 'In Bearbeitung', 'liegt vor'],
  statikgutachten_status: ['Positiv', 'In Bearbeitung', 'liegt vor'],
  rangruecktritt: ['In Bearbeitung', 'Bestätigt', 'liegt vor'],
  statik_vorpruefung: ['Positiv', 'In Bearbeitung'],
  netzstatus: ['Netzanfrage gestellt', 'Netzzusage liegt vor'],
  spannungsebene: ['Niederspannung', 'Mittelspannung', 'Hochspannung'],
  pachtart: ['einmal', 'jaehrlich', 'sanierung'],
  status: ['Ready to Build', 'Ready to Invest', 'in Planung'],
  gestattungsvertraege_status: ['in Bearbeitung', 'liegt vor'],
  sanierungsbedarf: ['Ja', 'Nein', 'nicht bekannt'],
  statikgutachten_angefordert: ['Ja', 'in Bearbeitung'],
  statiker_freigabe: ['Ja', 'in Bearbeitung'],
  netzverknuepfungspunkt: ['Hausanschluss', 'ZAS', 'vorhandener Trafo', 'kundeneigene Trafostation'],
};

export function getExposeFieldOptions(placeholder) {
  const field = EXPOSE_PLACEHOLDER_FIELDS.find((f) => f.placeholder === placeholder);
  if (!field) return null;
  for (const dk of field.dataKeys || []) {
    if (EXPOSE_FIELD_OPTIONS[dk]) return EXPOSE_FIELD_OPTIONS[dk];
  }
  return null;
}

// Formel-Auswertung für Standardwerte: Werte die mit '=' beginnen werden als
// einfache Formeln interpretiert. Feldverweise über {dataKey} oder {Platzhalter}.
// Unterstützt +, -, *, / und Dezimalzahlen. Gibt den formatierten Ergebniswert
// als String zurück, oder null bei Parse-/Eval-Fehlern.
export function evaluateDefaultFormula(formula, project, placeholderFields) {
  if (!formula || typeof formula !== 'string' || !formula.startsWith('=')) return null;
  const expr = formula.slice(1).trim();
  if (!expr) return null;

  const placeholderToDataKey = {};
  (placeholderFields || EXPOSE_PLACEHOLDER_FIELDS).forEach((f) => {
    (f.dataKeys || []).forEach((dk) => { placeholderToDataKey[f.placeholder] = dk; });
  });

  const resolved = expr.replace(/\{([^}]+)\}/g, (_, ref) => {
    const trimmed = ref.trim();
    const dataKey = placeholderToDataKey[trimmed] || trimmed;
    const raw = project?.[dataKey];
    if (raw === undefined || raw === null || String(raw).trim() === '') return 'NaN';
    const num = parseFloat(String(raw).replace(/\./g, '').replace(',', '.').replace(/[^\d.\-]/g, ''));
    return isNaN(num) ? 'NaN' : String(num);
  });

  if (/NaN/.test(resolved)) return null;
  if (!/^[\d\s+\-*/().]+$/.test(resolved)) return null;

  try {
    const result = Function('"use strict"; return (' + resolved + ')')();
    if (typeof result !== 'number' || !isFinite(result)) return null;
    const rounded = Math.round(result * 100) / 100;
    return String(rounded).replace('.', ',');
  } catch (_) {
    return null;
  }
}

export const EXPOSE_FIELD_DEFAULTS_CONTRACT_KEY = 'expose-field-defaults';

const PV_PLACEHOLDERS = [
  'Projektname', 'Kundenname', 'Kundenadresse', 'Angebotsnummer', 'Kundennummer',
  'Datum', 'Gültig bis', 'Projektbild', 'Lageplan', 'Projekt-ID', 'Status',
  'Gemeinde', 'Projektstandort',
  'Leistung kWp', 'Dachfläche', 'Spezifischertrag', 'Jahresertrag',
  'Modultyp', 'Modulanzahl', 'Modulleistung', 'Wechselrichter',
  'Kaufpreis', 'Preis pro kWp', 'Kaufpreis Projektrecht', 'Preis Projektrecht pro kWp',
  'EEG Vergütung', 'Jahreserlös',
  'Art der Pacht', 'Einmalzahlung Pacht pro kWp', 'Einmalzahlung Pacht Gesamt',
  'Jährliche Zahlung', 'Verlängerungsoption', 'VL Prozent',
  'Projektstatus', 'Bundesland', 'Gemarkung', 'Flurstück', 'Dachtyp',
  'Pachtvertrag Status', 'Pachtlaufzeit', 'Pachtbeginn', 'Pachtkosten',
  'Statikgutachten Status', 'Grundbucheintragung Status',
  'Sanierungsbedarf', 'Statik-Vorprüfung', 'Statik-Gutachten angefordert', 'Freigabe Statiker',
  'Netzstatus', 'Netzanschluss', 'Spannungsebene', 'Netzverknüpfungspunkt',
  'Netzentfernung', 'Netzbetreiber',
  'PVSol Standort', 'PVSol Quelle', 'PVSol Generatorleistung',
  'PVSol Spezifischer Jahresertrag', 'PVSol Netzeinspeisung', 'PVSol CO2',
  'PVSol Generatorfläche', 'PVSol Module', 'PVSol Wechselrichter',
  'Amtsgericht', 'Grundbuch Abdruck vom', 'Grundbuch belastet', 'Rangrücktritt',
  'Ansprechpartner', 'Position', 'Telefonnummer', 'E-Mail', 'Website',
];

const TURNKEY_EXTRA = [
  'Kaufpreis Turnkey', 'Kaufpreis Turnkey pro kWp',
  'IRR', 'Rendite', 'Amortisation', 'Netto Erlös 20 Jahre',
  'EEG Anteil', 'Netto Vergütung',
  'Dachpacht', 'Versicherung', 'Wartung', 'OPEX',
  'Inbetriebnahme', 'O&M Vertrag',
  'Cashflow Jahr 1', 'Cashflow Ertrag 1', 'Cashflow Erlös 1', 'Cashflow OPEX 1', 'Cashflow Netto 1',
  'Cashflow Jahr 5', 'Cashflow Ertrag 5', 'Cashflow Erlös 5', 'Cashflow OPEX 5', 'Cashflow Netto 5',
  'Cashflow Jahr 10', 'Cashflow Ertrag 10', 'Cashflow Erlös 10', 'Cashflow OPEX 10', 'Cashflow Netto 10',
  'Cashflow Jahr 15', 'Cashflow Ertrag 15', 'Cashflow Erlös 15', 'Cashflow OPEX 15', 'Cashflow Netto 15',
  'Cashflow Jahr 20', 'Cashflow Ertrag 20', 'Cashflow Erlös 20', 'Cashflow OPEX 20', 'Cashflow Netto 20',
  'Cashflow Jahr 25', 'Cashflow Ertrag 25', 'Cashflow Erlös 25', 'Cashflow OPEX 25', 'Cashflow Netto 25',
  'Stromgestehungskosten', 'Eigenkapitalrendite', 'Betrachtungszeitraum',
  'Degradation', 'Vergütungszeitraum', 'EEG Tarif Name',
  'Wirtschaftlichkeit Cashflow JSON', 'Inbetriebnahme Datum',
  'Netzeinspeisung', 'Kapitalwert', 'Gesamtvergütung',
  'EEG Vergütungsstufen JSON',
];

const WIRT_PLACEHOLDERS = [
  'Projektname', 'Kundenname', 'Kundenadresse', 'Angebotsnummer', 'Datum',
  'Projektbild', 'Lageplan', 'Projektstatus',
  'Leistung kWp', 'Dachfläche', 'Spezifischertrag', 'Jahresertrag',
  'EEG Vergütung', 'Jahreserlös', 'OPEX',
  'Kaufpreis Turnkey', 'Kaufpreis Turnkey pro kWp',
  'IRR', 'Rendite', 'Amortisation', 'Netto Erlös 20 Jahre',
  'Stromgestehungskosten', 'Eigenkapitalrendite', 'Betrachtungszeitraum',
  'Degradation', 'Vergütungszeitraum', 'EEG Tarif Name',
  'Wirtschaftlichkeit Cashflow JSON', 'Inbetriebnahme Datum',
  'Netzeinspeisung', 'Kapitalwert', 'Gesamtvergütung',
  'EEG Vergütungsstufen JSON',
  'PVSol Generatorleistung', 'PVSol Netzeinspeisung',
  'Ansprechpartner', 'Position', 'Telefonnummer', 'E-Mail',
];

export const EXPOSE_VARIANT_PLACEHOLDERS = {
  'expose-projektverkauf': new Set(PV_PLACEHOLDERS),
  'expose-turnkey': new Set([...PV_PLACEHOLDERS, ...TURNKEY_EXTRA]),
  'expose-wirtschaftlichkeit': new Set(WIRT_PLACEHOLDERS),
};

export function isFieldUsedByVariant(field, variantKey) {
  const placeholders = EXPOSE_VARIANT_PLACEHOLDERS[variantKey];
  if (!placeholders) return true;
  return placeholders.has(field.placeholder);
}
